import { Component, HostBinding, ViewEncapsulation } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'form-date-field',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  styles: [
    '.form-date-field { display:flex;     flex: 1; .p-datepicker {flex: 1;} }',
  ],
  template: `
    <p-iftalabel class="flex-1">
      <p-datepicker
        [formControl]="formControl"
        [formlyAttributes]="field"
        [iconDisplay]="'input'"
        [showIcon]="true"
        [dateFormat]="'yy-mm-dd'"
        [dataType]="'string'"
        [inputId]="field.id"
        class="w-full flex"
        [pTooltip]="
          field.props['translate']
            ? (field.props['tooltip'] || '' | translate)
            : field.props['tooltip']
        "
        tooltipPosition="top"
      />

      <label *ngIf="field.props.label" [htmlFor]="field.id">{{
        field.props.label
      }}</label>
    </p-iftalabel>
  `,
})
export class FormDateFieldType extends FieldType<FieldTypeConfig> {
  @HostBinding('class')
  readonly cssClass = 'form-date-field';
}
